import { render, staticRenderFns } from "./_ExtraDialogRow.vue?vue&type=template&id=2f2a133c"
import script from "./_ExtraDialogRow.vue?vue&type=script&lang=js"
export * from "./_ExtraDialogRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports